var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.item.type)?_c('div',{staticClass:"wdTag",style:(`background:url(${_vm.ConstData.courseSource[+_vm.item.type].picUrl}) no-repeat left top;background-size:cover`)},[_c('p',{staticClass:"text",class:_vm.ConstData.courseSource[+_vm.item.type].type},[_vm._v(_vm._s(_vm.ConstData.courseSource[+_vm.item.type].text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }